/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Employer } from './types';

// TODO: Figure out if we want to break this up into multiple contexts
export interface AdminContextProps {
  employer: Employer | undefined,
  isAdmin: boolean,
  // TODO remove if remains unused
  isEmployerAdmin?: boolean | null,
  // TODO remove if remains unused
  employerAdminsFor?: string[] | null,
  isLoading: boolean,
  isCompany: boolean,
  isSubCompany: boolean,
  isLevelOne: boolean,
  setEmployer(employer: Employer): void;
  setIsAdmin(isAdmin: boolean): void;
  // TODO remove if remains unused
  setIsEmployerAdmin(isEmployerAdmin: boolean): void;
  // TODO remove if remains unused
  setEmployerAdminsFor(employerAdminRoleNames: string[]): void;
  setIsSubCompany(isSubCompany: boolean): void;
  setIsLevelOne(isLevelOne: boolean): void;
  refreshUserData(): void;
}

export const AdminContext = React.createContext<AdminContextProps>({
  employer: undefined,
  isAdmin: false,
  // TODO remove if remains unused
  isEmployerAdmin: null,
  // TODO remove if remains unused
  employerAdminsFor: null,
  isCompany: false,
  isSubCompany: false,
  isLevelOne: false,
  isLoading: true,
  setEmployer: (_): void => { return; },
  setIsAdmin: (_): void  => { return; },
  setIsEmployerAdmin: (_): void  => { return; },
  setEmployerAdminsFor: (_): void => { return; },
  setIsSubCompany: (_): void => { return; },
  setIsLevelOne: (_): void => { return; },
  refreshUserData: (): void => { return; }
});